export const defaultCurrencies = [
  { country: "", countryCode: "", currency: "US Dollar", code: "USD" },
  { country: "", countryCode: "", currency: "Euro", code: "EUR" },
]

export const legalEntityData = [
  {
    country: "United States",
    countryCode: "US",
    currency: "US Dollar",
    code: "USD",
  },
  {
    country: "United Kingdom",
    countryCode: "GB",
    currency: "British Pound",
    code: "GBP",
  },
  { country: "Germany", countryCode: "DE", currency: "Euro", code: "EUR" },
  { country: "Germany", countryCode: "DE", currency: "US Dollar", code: "USD" },
  {
    country: "Netherlands",
    countryCode: "NL",
    currency: "US Dollar",
    code: "USD",
  },
  { country: "Netherlands", countryCode: "NL", currency: "Euro", code: "EUR" },
  { country: "Belgium", countryCode: "BE", currency: "Euro", code: "EUR" },
  { country: "France", countryCode: "FR", currency: "Euro", code: "EUR" },
  { country: "Finland", countryCode: "FI", currency: "Euro", code: "EUR" },
  {
    country: "Australia",
    countryCode: "AU",
    currency: "Australian Dollar",
    code: "AUD",
  },
  {
    country: "Brazil",
    countryCode: "BR",
    currency: "Brazilian Real",
    code: "BRL",
  },
  {
    country: "Canada",
    countryCode: "CA",
    currency: "Canadian Dollar",
    code: "CAD",
  },
  { country: "Canada", countryCode: "CA", currency: "US Dollar", code: "USD" },
]
